import('./style.scss')

'use strict';

export class CatalogElement
{
    constructor(offers, options = {})
    {
        this.options = options
        this.offers = offers
        this.init()
    }

    init()
    {
        const self = this
        $('input[name="gearbox_type"]').on('change', function() {
            let input = $(this)
            self.changeSku(input.data('xml'))
            self.changeDetailText(input.data('xml'))
            self.changeSpec(input.data('xml'))
            self.changeScheme(input.data('xml'))
            self.changePhotos(input.data('xml'))
        });

        $('.js-3d').on('click', function(e){
            e.preventDefault()
            let elem = $(this)

            $.ajax({
                url: '/local/ajax/api/v1/3dviewer.php',
                data: {path: elem.attr('href')},
                method: 'POST',
                success: function(result) {
                    $.fancybox.open({
                        src  : result,
                        type : 'html',
                        opts : {
                            touch: false, // Allow to drag content vertically
                        }
                    })
                }
            })
        })
    }

    changeSku(xml)
    {
        $('.price-value').html(this.offers[xml].PRICE);
        $('.add_to_basket').attr('data-id', this.offers[xml].ID);
        let btn_3d = $('.js-3d')
        if (this.offers[xml].MODEL_VIEWER) {
            btn_3d.removeClass('d-none')
            btn_3d.attr('href', this.offers[xml].MODEL_VIEWER)
            console.log(this.offers[xml].MODEL_VIEWER)
        } else {
            btn_3d.addClass('d-none')
        }
    }

    changeDetailText(xml)
    {
        $('#detail-text-container').html(this.offers[xml].DETAIL_TEXT);
    }

    changeSpec(xml)
    {
        $('#spec-container').html(this.offers[xml].SPEC);
    }

    changeScheme(xml)
    {
        $('#scheme-container').html(this.offers[xml].SCHEME);
    }

    changePhotos(xml)
    {
        $('.slider').addClass('d-none');
        $('.slider[data-id="'+this.offers[xml].ID+'"]').removeClass('d-none');
    }

}